import * as React from 'react'
import { Alert, Button, Col, Modal, Result, Row } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { useStore, useUnit } from 'effector-react'
import { useCommentsList } from '../../../../views/widgets/commentList'
import {
  $commentsError,
  commentListMounted,
  deleteCommentRequest,
} from '../../../../views/widgets/commentList/model'
import { $userProfile, $userRole } from '../../../../features/user'
import { role } from '../../../../libs'

type Props = {
  entityType: string
  entityId: string
}

const mapAlertType = (type: number) => {
  switch (type) {
    case 0:
      return 'error' as const
    case 1:
      return 'warning' as const
    case 2:
      return 'info' as const
    default:
      return 'success' as const
  }
}

export const VerificationCommentList = ({ entityType, entityId }: Props) => {
  const { comments } = useCommentsList({ entityType, entityId })
  const userRole = useStore($userRole)
  const userProfile = useStore($userProfile)
  const commentsError = useUnit($commentsError)

  if (![0, 404, null].includes(commentsError?.code || null)) {
    return (
      <Result
        status="error"
        title="Ошибка"
        subTitle="При выполнении запроса произошла ошибка"
        extra={
          <Button
            type="primary"
            onClick={() => commentListMounted({ entityType, entityId })}
          >
            Попробовать снова
          </Button>
        }
      />
    )
  }

  return (
    <Row>
      {comments.map((comment) => {
        const date = new Date(comment.createdAt)
        return (
          <Col xs={24} key={comment.commentId}>
            <div style={{ position: 'relative' }}>
              <Alert
                className="mb-2"
                style={{ fontSize: 12 }}
                message={
                  <span style={{ fontSize: 12 }}>
                    {(comment.user?.username || 'No information about user') +
                      ' / ' +
                      comment.department +
                      ' / ' +
                      date.toUTCString()}
                  </span>
                }
                description={
                  <span style={{ fontSize: 12 }}>{comment.message}</span>
                }
                type={mapAlertType(comment.type)}
              />
              {(userRole?.includes(role.root()) ||
                userProfile.id === comment.user?.id) && (
                <CloseOutlined
                  style={{
                    position: 'absolute',
                    top: 5,
                    right: 5,
                    color: '#ff4d4f',
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    Modal.confirm({
                      title: 'Delete comment',
                      content:
                        'Are you sure you want to delete this comment?',
                      okText: 'Delete',
                      cancelText: 'Cancel',
                      okButtonProps: { danger: true },
                      onOk: () =>
                        deleteCommentRequest({
                          url: `/comment/${comment.commentId}`,
                        }),
                    })
                  }
                />
              )}
            </div>
          </Col>
        )
      })}
    </Row>
  )
}
